import { Factory, association } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  floor: association(),
  name: () => faker.lorem.word(),
  neighborhood: () => faker.lorem.word(),
  x: () => faker.number.float({ min: 0, max: 1, precision: 0.0001 }),
  y: () => faker.number.float({ min: 0, max: 1, precision: 0.0001 }),
  enabled: true,
  assignedTo: null,
  deskAvailability: null, // graphql-server returns null, instead of `available`]
  shouldCreateUtilization: true,
  assignments: null,

  afterCreate(desk, server) {
    if (desk.shouldCreateUtilization) {
      server.create('graphql/desk-utilization', {
        desk,
        percentUtilized: faker.number.float({ min: 0, max: 1, precision: 0.0001 }),
      });
    }
  },
});
